export default "__VITE_ASSET__fa4b5082__"